import { random } from '../utils/random';
import { calculateSize } from '../utils/size';
import { Entity } from './Entity';
import { enemies } from '../configs/enemies';

export class Enemy implements Entity {
  public y: number = -200;
  public points: number;
  private speed: number;
  public width;
  public height;
  public resource;

  constructor(public x: number) {
    const config = enemies[random(0, enemies.length - 1)];
    this.points = config.points;
    this.speed = config.speed;
    this.resource = config.resource;
    const [width, height] = calculateSize(config.resource, config.size);
    this.width = width;
    this.height = height;
  }

  get position(): Entity['position'] {
    return [this.x, this.y];
  }

  get size(): Entity['size'] {
    return [this.width, this.height];
  }

  move(dt: number): Entity['position'] {
    this.y += this.speed * dt;
    return this.position;
  }
}
